import { memo, useContext } from 'react';
import { ConfigContext } from 'src/configContext';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { WarningCircleIcon } from 'src/modules/common/icons/WarningCircleIcon';

export const ActuatorHomeInfo = memo(() => {
    const { userSettings } = useContext(ConfigContext);

    return (
        <div className="vss-actuator-home-info">
            <div className="vss-actuator-home-info__icon">
                <WarningCircleIcon/>
            </div>

            <div className="vss-actuator-home-info__contents">
                <p className="vss-actuator-home-info__text">
                    <I18n messageId={MESSAGES.ActuatorHomeInfoTitle}/>
                </p>

                <ul className="vss-actuator-home-info__list-wrapper">
                    <li>
                        <p className="vss-actuator-home-info__text">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo1}/>
                            &nbsp;
                            <a
                                href={`https://www.belimo.com/${
                                    userSettings.currentCountry.toLowerCase()
                                }/${
                                    userSettings.currentLocale
                                }/products/retrofit-app.html`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <I18n messageId={MESSAGES.ActuatorHomeInfoLink}/>
                            </a>
                        </p>
                    </li>

                    <li>
                        <p className="vss-actuator-home-info__text">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo2}/>
                        </p>
                    </li>

                    <li>
                        <p className="vss-actuator-home-info__text">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo3}/>
                        </p>
                    </li>

                    <li>
                        <p className="vss-actuator-home-info__text">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo4}/>
                        </p>
                    </li>

                    <li>
                        <p className="vss-actuator-home-info__text">
                            <I18n messageId={MESSAGES.ActuatorHomeInfo5}/>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    );
});
